import React, { useState } from 'react';
import SosSearchFields from './SearchViewComponents/SosSearchFields';
import CurrentSearch from './SearchViewComponents/CurrentSearch';
import PreviousSearches from './SearchViewComponents/PreviousSearches';
import strings from 'strings';
import { Toast } from 'components/shared/Toaster'
import {sosQuickSearch, requestSosSearch, requestSosSearchDemoMode, sosQuickSearchDemoMode} from 'actions/applicants'
import SavedRecords from './SearchViewComponents/SavedRecords';
import {useAppContext} from "../../../context/AppContext";

const sosStrings = strings.APPLICANT.SOS

const SearchView = (props) => {

    const { viewResult, isQuickSearch, applicantId, creditCosts, refreshSavedRecords } = props
    const { isDemoMode } = useAppContext()
    const performSearch = isQuickSearch ? (isDemoMode ? sosQuickSearchDemoMode : sosQuickSearch)
        : (isDemoMode ? requestSosSearchDemoMode: requestSosSearch)

    // data
    const [currentSearch, setCurrentSearch] = useState(false)
    const [searchLoading, setSearchLoading] = useState(false)

    // control variables
    const [update, setUpdate] = useState(false) // update previous searches
    const [savedRecordsRefresh, setSavedRecordsRefresh] = useState(false) // update saved records

    //functions
    const handleSosSearch = (payload) => {
        setSearchLoading(true)
        setCurrentSearch(false)
        let info = { payload }
        if (!isQuickSearch) info.applicationId = applicantId
        performSearch(info)()
            .then(res => {
                setCurrentSearch(res)
                setUpdate(prev => !prev)
            })
            .catch(err => Toast({ type: 'error', message: sosStrings.SEARCH_ERROR }))
            .finally(() => setSearchLoading(false))
    }

    const handleRefreshSavedRecords = () => {
        setSavedRecordsRefresh(prev => !prev)
    }

    return (
        <>
            <div className='cardStyle mb-3'>
                <h5 className='mb-0'>{sosStrings.SOS}</h5>
                <SosSearchFields loading={searchLoading} handleSosSearch={handleSosSearch} isQuickSearch={isQuickSearch}
                                 creditCosts={creditCosts}/>
                {
                    currentSearch &&
                    <CurrentSearch
                        currentSearch={currentSearch}
                        viewResult={viewResult}
                        search={handleSosSearch}
                        isQuickSearch={isQuickSearch}
                        applicantId={applicantId}
                        refreshSavedRecords={handleRefreshSavedRecords}
                        creditCosts={creditCosts}
                    />
                }
            </div>
            <PreviousSearches update={update} viewResult={viewResult} search={handleSosSearch} searchLoading={searchLoading} isQuickSearch={isQuickSearch} applicantId={applicantId} creditCosts={creditCosts}/>
            {applicantId && <SavedRecords applicantId={applicantId} viewResult={viewResult} refreshTrigger={savedRecordsRefresh} />}
        </>
    )
}

export default SearchView